import React from 'react';

const InsuranceIcon = ({ type, size = 20, className = '' }) => {
  const emojis = {
    single: '✈️',
    national: '🚌',
    multiple: '🌍',
    seniors: '👴👵',
  };

  const emoji = emojis[type];

  if (!emoji) {
    return null;
  }

  return (
    <span
      className={className}
      style={{
        fontSize: `${size}px`,
        lineHeight: 1,
        display: 'inline-block',
      }}
      role="img"
      aria-label={`${type} insurance`}
    >
      {emoji}
    </span>
  );
};

export default InsuranceIcon;
